import { useAtomValue } from 'jotai';
import { Provider } from 'jotai';
import { lazy, Suspense } from 'react';

import { jotaiDevToolsVisibleAtom } from '@/features/developer-tools/third-party-tools/third-party-devtools.state';

import { jotaiStore } from './jotai-store';

const LazyJotaiDevTools = lazy(() =>
  Promise.all([import('jotai-devtools'), import('jotai-devtools/styles.css?inline')]).then(
    ([devtools, css]) => ({
      default: () => (
        <>
          <style>{css.default as string}</style>
          <devtools.DevTools store={jotaiStore} theme="dark" position="top-right" />
        </>
      ),
    })
  )
);

const JotaiDevToolsGated = () => {
  const visible = useAtomValue(jotaiDevToolsVisibleAtom);
  if (!visible) return null;

  return (
    <Suspense fallback={null}>
      <LazyJotaiDevTools />
    </Suspense>
  );
};

export const JotaiProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <Provider store={jotaiStore}>
      <JotaiDevToolsGated />
      {children}
    </Provider>
  );
};
